import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { UplotRangePickerComponent } from '../../../../../shared/components/graph-uplot/uplot-range-picker/uplot-range-picker.component';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardPieChartAggComponent } from './dashboard-pie-chart-agg.component';

@Component({
  selector: 'app-dashboard-pie-chart-monthly-agg',
  standalone: true,
  imports: [
    BaseChartDirective,
    UplotRangePickerComponent,
    AsyncPipe,
    MatProgressBar,
    TranslateModule,
  ],
  providers: [TitleCasePipe],
  templateUrl: './dashboard-pie-chart.component.html',
  styleUrl: './dashboard-pie-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPieChartMonthlyAggComponent extends DashboardPieChartAggComponent {
  override getSeriesLength() {
    return 12;
  }

  override seriesIndexExtraction(date: Date): number {
    return date.getMonth();
  }

  override getSeriesLabel(i: number) {
    const date = this.seriesDate[i as number];
    if (!date) return null;
    const month = this.capitalize.transform(
      date.toLocaleString(this.localeService.locale, {
        month: 'long',
        timeZone: this.localeService.timezone,
      }),
    );

    return `${month} (${date.getFullYear()})`;
  }
}
